import { Col, Row } from "react-bootstrap";
import {
  FiUserPlus,
  FiCalendar,
  FiFolderPlus,
  FiClock,
  FiPackage,
  FiUmbrella,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      label: "Add User",
      icon: <FiUserPlus />,
      path: "/users",
    },
    {
      label: "Apply Leave",
      icon: <FiCalendar />,
      path: "/leave",
    },
    {
      label: "Create Project",
      icon: <FiFolderPlus />,
      path: "/projects",
    },
    {
      label: "Assign Shift",
      icon: <FiClock />,
      path: "/shift-management",
    },
    {
      label: "Add Asset",
      icon: <FiPackage />,
      path: "/assets",
    },
    {
      label: "Add Holiday",
      icon: <FiUmbrella />,
      path: "/holidays",
    },
  ];

  return (
    <div className="glass-card" style={{ padding: "0.75rem" }}>
      <h4 className="chart-title mb-2">Quick Actions</h4>

      <Row className="g-2">
        {quickActions.map((action, index) => (
          <Col key={index} xs={6} md={4} lg={2}>
            <button
              type="button"
              className="quick-action-btn"
              onClick={() => navigate(action.path)}
            >
              <div className="quick-action-icon">
                {action.icon}
              </div>
              <span className="quick-action-label">
                {action.label}
              </span>
            </button>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default QuickActions;